module.exports = __webpack_public_path__ + "img/icon_internet.cdbd6af.svg";